<div class="container-fluid">
  <div class="flex justify-content-between">
    <div class="dash-title">Chat Dashboard</div>
    <div class="filter-container ml-4">
      <mat-tab-group mat-stretch-tabs id="mat-label-change" (selectedTabChange)="onChangeTab($event)">
        <mat-tab label="Last 7 days"></mat-tab>
        <mat-tab label="Last 30 days"></mat-tab>
        <mat-tab label="Custom">
          <div class="custom-head">
            <input type="date" class="cust-date" [style.color]='customStartDateSelected==true?" #2596FF":"#C4C4C4"'
              placeholder="mm/dd/yyyy" (change)="onSelectCustomDate(date1.value,1)" #date1 />
              <label class="set-hiphen">&#x2014;</label>
              <input type="date" class="cust-date date" [style.color]='customEndDateSelected==true?" #2596FF":"#C4C4C4"'
                placeholder="mm/dd/yyyy" (change)="onSelectCustomDate(date2.value,2)" #date2 />
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
      <div class="flex justify-content-between all-statistic">
        <div class="statistic-container">
          <div class="statistic-content">
            <div class="statistic-title">All Chats Initiated</div>
            <div class="statistic-count">{{allChatStatistics.chatsInitiated}}</div>
          </div>
        </div>
        <div class="statistic-container">
          <div class="statistic-content">
            <div class="statistic-title">All Human Chats Requested</div>
            <div class="statistic-count">{{allChatStatistics.humanChatsRequested}}</div>
          </div>
          <div class="percent-box">{{allChatStatistics.requestedPersent}}%</div>
        </div>
        <div class="statistic-container">
          <div class="statistic-content">
            <div class="statistic-title">All Human Chats Accepted</div>
            <div class="statistic-count">{{allChatStatistics.humanChatsAccepted}}</div>
          </div>
          <div class="percent-box">{{allChatStatistics.acceptedPersent}}%</div>
        </div>
      </div>
      <div class="chat-statistic-container">
        <div class="chat-statistic">
          <div class="select-chat">
            <select [(ngModel)]="questionnairesTree.answerId" (ngModelChange)="loadChat(questionnairesTree.answerId)">
              @for (chat of listChats; track chat) {
                <option [value]="chat.id">{{chat.title}}</option>
              }
            </select>
            <div class="sub-title">Select chat map</div>
          </div>
          <div class="flex flex-column">
            <div class="statistic-container">
              <div class="statistic-content">
                <div class="statistic-title">All Chats Initiated</div>
                <div class="statistic-count">{{chatStatistics.chatsInitiated}}</div>
              </div>
            </div>
            <div class="statistic-container">
              <div class="statistic-content">
                <div class="statistic-title">All Human Chats Requested</div>
                <div class="statistic-count">{{chatStatistics.humanChatsRequested}}</div>
              </div>
              <div class="percent-box">{{chatStatistics.requestedPersent}}%</div>
            </div>
            <div class="statistic-container">
              <div class="statistic-content">
                <div class="statistic-title">All Human Chats Accepted</div>
                <div class="statistic-count">{{chatStatistics.humanChatsAccepted}}</div>
              </div>
              <div class="percent-box">{{chatStatistics.acceptedPersent}}%</div>
            </div>
          </div>
          <div class="btn" (click)="openContactDetails()">Contact details</div>
        </div>
        <div class="chat-tree-container">
          <div class="chat-tree-title">Clicks</div>
          <div class="statistic-tree">
            <mat-tree #tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
              <!-- This is the tree node template for leaf nodes -->
              <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                <li class="mat-tree-node" [class.active-row]="activeQuestionnaires.answerId === node.id">
                  <!-- use a disabled button to provide padding for tree leaf -->
                  <div [style.left]="(-15 * node.level - 45) + 'px'" class="number-clicks">{{node.clicks || 0}} </div>
                  <button mat-icon-button disabled>
                    <div class="expand-icon"></div>
                  </button>
                  <div class="tree-label-wrap" (click)="openTreeBranch(node)">
                    <span>{{ node.prefix }} - </span>
                    <div class="inline-edit">{{node.treeLabel}}</div>
                  </div>
                </li>
              </mat-tree-node>
              <!-- This is the tree node template for expandable nodes -->
              <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild; let i = index;">
                <li [class.active-row]="activeQuestionnaires.answerId === node.id">
                  <div class="mat-tree-node">
                    <div [style.left]="(-15 * node.level - 45) + 'px'" class="number-clicks">{{node.clicks || 0}} </div>
                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.buttonText">
                      <div class="expand-icon" [class.rotate]="treeControl.isExpanded(node)"></div>
                    </button>
                    <div class="tree-label-wrap" (click)="openTreeBranch(node)">
                      <span>{{ node.prefix }} - </span>
                      <div class="inline-edit">{{node.treeLabel}}</div>
                    </div>
                  </div>
                  <ul [class.example-tree-invisible]="!treeControl.isExpanded(node)">
                    <ng-container matTreeNodeOutlet></ng-container>
                  </ul>
                </li>
              </mat-nested-tree-node>
            </mat-tree>
          </div>
        </div>
      </div>
    </div>